<!-- Fixed Sidebar Right -->
<link
rel="stylesheet"
data-purpose="Layout StyleSheet"
title="Web Awesome"
href="/css/app-wa-86cd56275caec687041f80b17dc62e32.css?vsn=d"
>

<link
  rel="stylesheet"
  href="https://site-assets.fontawesome.com/releases/v5.15.4/css/all.css"
>
<div class="fixed-sidebar right" >
    <aside class="sidebar">
        <div class="sidebar-header">
            &nbsp;
          <h2>&nbsp;</h2>
        </div>
        <ul class="sidebar-links">
          <h4>
            <span>Importent Menu</span>
            <div class="menu-separator"></div>
          </h4>
          <li>
            <a href="/newsfeed"><span class="material-symbols-outlined"> <i class="fad fa-newspaper" style="font-size: 25px; color: forestgreen;"></i> </span>Last Posts</a>
          </li>
          <li>
            <a href="/ranking"><span class="material-symbols-outlined"> <i class="fad fa-trophy" style="font-size: 25px; color: rgb(84, 37, 99);"></i> </span>Ranking</a>
          </li>
          <li>
            <a href="/calling-members"><span class="material-symbols-outlined"> <i class="fad fa-video" style="font-size: 25px; color: deepskyblue;"></i> </span>Meeting Rooms</a>
          </li>
          <li>
            <a href="/chat"><span class="material-symbols-outlined"> <i class="fad fa-comments" style="font-size: 25px; color: olive;"></i> </span>Chat</a>
          </li>
          <li>
            <a href="/voting"><span class="material-symbols-outlined"> <i class="fad fa-vote-yea" style="font-size: 25px; color: coral;"></i> </span>Voting</a>
          </li>
          <li>
            <a href="/weather"><span class="material-symbols-outlined"> <i class="fad fa-sun" style="font-size: 25px; color: sienna;"></i> </span>Weather</a>
          </li>
          <li>
            <a href="/statistics">
              <span class="material-symbols-outlined"> <i class="fad fa-chart-pie" style="font-size: 25px; color: rgb(112, 42, 146);"></i> </span>Statistics</a>
          </li>
          <h4>
            <span>Personal Menu</span>
            <div class="menu-separator"></div>
          </h4>
          <li>
            <a href="/profile"><span class="material-symbols-outlined"> <i class="fad fa-id-card" style="font-size: 25px; color: brown;"></i> </span>Profile</a>
          </li>
          <li>
            <a href="/profile-setting">
              <span class="material-symbols-outlined"> <i class="fad fa-user-cog" style="font-size: 25px; color: rgb(68, 68, 68);"></i> </span>Profile Setting</a>
          </li>
          <li>
            <a href="/admin">
              <span class="material-symbols-outlined"> <i class="fad fa-tools" style="font-size: 25px; color: rgbrgb(50, 100, 50)"></i> </span>Admin Control</a>
          </li>
          <li>
            <a href="/friends">
              <span class="material-symbols-outlined"> <i class="fad fa-user-friends" style="font-size: 25px; color: rgb(56, 129, 95);"></i> </span>Friends</a>
          </li>
          <li>
            <a href="/find-friends">
              <span class="material-symbols-outlined"> <i class="fad fa-search-plus" style="font-size: 25px; color: rgb(89, 82, 153);"></i> </span>Find Friends</a>
          </li>
          <li>
            <a (click)="logout()">
              <span class="material-symbols-outlined"> <i class="fad fa-sign-out-alt" style="font-size: 25px; color: rgb(207, 0, 0);"></i> </span>Log Out</a>
          </li>
          <li>
            
          </li>
        </ul>
      </aside>
      
</div>